import { render } from "./URight.vue?vue&type=template&id=508a1760&scoped=true"
import script from "./URight.vue?vue&type=script&lang=js"
export * from "./URight.vue?vue&type=script&lang=js"

import "./URight.vue?vue&type=style&index=0&id=508a1760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508a1760"]])

export default __exports__